import {
  Button,
  DatePicker,
  Popover,
  PopoverContent,
  PopoverAction,
  Label,
} from 'keep-react'
import { Calendar } from 'phosphor-react'
import { format } from 'date-fns'
import { pt } from 'date-fns/locale'
import { useEffect, useState } from 'react'

export const FormDate = ({
  formik,
  label,
  name,
  required,
  inline,
  extraClasses,
  action,
}: {
  formik: any
  label: string
  name: string
  required?: boolean
  inline?: boolean
  extraClasses?: string
  disabled?: boolean
  action?: (date: string) => void
}) => {
  const field = formik.getFieldProps(name)
  const { error } = formik.getFieldMeta(name)
  const [date, setDate] = useState<Date>(
    field.value ? parseDate(field.value) : new Date(),
  )

  useEffect(() => {
    if (date) {
      const formatted = format(date, 'yyyy-MM-dd')
      formik
        ? formik.setFieldValue(name, formatted)
        : action && action(formatted)
    }
  }, [date])

  function parseDate(value: any): Date {
    if (value instanceof Date) return value
    if (typeof value === 'string') {
      const [day, month, year] = value.split('/')
      if (day && month && year) {
        return new Date(Number(year), Number(month) - 1, Number(day))
      }
      const d = new Date(value)
      if (!isNaN(d.getTime())) return d
    }
    return new Date()
  }

  return (
    <div className="flex flex-col">
      {label && (
        <Label className={`text-body-4 block`}>
          {label}
          {required && <span className="text-primary-600">*</span>}
        </Label>
      )}

      <Popover>
        <PopoverAction
          asChild
          className={`relative w-full ${inline ? 'flex items-center' : ''} ${
            extraClasses ?? ''
          }`}
        >
          <Button
            color="secondary"
            size="lg"
            className="w-full flex items-center justify-start gap-2.5 border border-metal-100 text-body-4"
            variant="outline"
          >
            <Calendar size={20} className="text-metal-400 dark:text-white" />
            {date ? format(date, 'dd/MM/yyyy') : <span>{label}</span>}
          </Button>
        </PopoverAction>
        <PopoverContent align="start" className="max-w-min border-0">
          <DatePicker
            mode="single"
            selected={date}
            onSelect={(d: any) => d && setDate(d)}
            showOutsideDays={true}
            locale={pt}
          />
        </PopoverContent>
      </Popover>

      {error && (
        <span className="py-2 block w-full text-body-5 text-error-600">
          {error}
        </span>
      )}
    </div>
  )
}
